module.exports = "/assets/data/2bb526343317fed2175767a98bd762a7-TS9.data.json";